export const TIMEZONE_DATA = {
    'United States': [
        { value: 'GMT-10:00', label: '(GMT-10:00) Hawaii' },
        { value: 'GMT-09:00', label: '(GMT-09:00) Alaska' },
        { value: 'GMT-08:00', label: '(GMT-08:00) Pacific Time (US & Canada)' },
        { value: 'GMT-07:00', label: '(GMT-07:00) Mountain Time (US & Canada)' },
        { value: 'GMT-06:00', label: '(GMT-06:00) Central Time (US & Canada)' },
        { value: 'GMT-05:00', label: '(GMT-05:00) Eastern Time (US & Canada)' }
    ],
    'United Kingdom': [
        { value: 'GMT+00:00', label: '(GMT+00:00) London, Edinburgh, Dublin' },
        { value: 'GMT+01:00', label: '(GMT+01:00) British Summer Time' }
    ],
    'India': [
        { value: 'GMT+05:30', label: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi' }
    ],
    'Australia': [
        { value: 'GMT+08:00', label: '(GMT+08:00) Australian Western Standard Time' },
        { value: 'GMT+09:30', label: '(GMT+09:30) Australian Central Standard Time' },
        { value: 'GMT+10:00', label: '(GMT+10:00) Australian Eastern Standard Time' }
    ],
    'Canada': [
        { value: 'GMT-08:00', label: '(GMT-08:00) Pacific Time (US & Canada)' },
        { value: 'GMT-07:00', label: '(GMT-07:00) Mountain Time (US & Canada)' },
        { value: 'GMT-06:00', label: '(GMT-06:00) Central Time (US & Canada)' },
        { value: 'GMT-05:00', label: '(GMT-05:00) Eastern Time (US & Canada)' },
        { value: 'GMT-04:00', label: '(GMT-04:00) Atlantic Time (Canada)' },
        { value: 'GMT-03:30', label: '(GMT-03:30) Newfoundland Time' }
    ],
    'Japan': [
        { value: 'GMT+09:00', label: '(GMT+09:00) Tokyo, Osaka, Sapporo' }
    ],
    'China': [
        { value: 'GMT+08:00', label: '(GMT+08:00) Beijing, Shanghai' }
    ],
    'Germany': [
        { value: 'GMT+01:00', label: '(GMT+01:00) Berlin, Hamburg, Munich' }
    ],
    'France': [
        { value: 'GMT+01:00', label: '(GMT+01:00) Paris' }
    ],
    'United Arab Emirates': [
        { value: 'GMT+04:00', label: '(GMT+04:00) Dubai, Abu Dhabi' }
    ]
};

export const COUNTRIES = Object.keys(TIMEZONE_DATA).sort();
